import { config } from "../../../../config";

function adsWizzCompanionOutOfContextFunction() {
  console.log("<<<<BANNER LISTENER>>>>> adsWizzCompanionOutOfContextFunction");
}

function adsWizzCompanionWillDisplayFunction(companionBannerURLString: string) {
  console.log("<<<<BANNER LISTENER>>>>> adsWizzCompanionWillDisplayFunction srcURL = " + companionBannerURLString);
}

function adsWizzCompanionWillDisplayFallbackFunction(fallbackBannerULRString: string) {
  console.log("<<<<BANNER LISTENER>>>>> adsWizzCompanionWillDisplayFallbackFunction srcURL = " + fallbackBannerULRString);
}

let cachedTCFString: string | null = null;

/**
 * Gets the IAB TCF String using the TCF API
 * @returns {Promise<string|null>} The IAB TCF String or null if not found
 */
export const getIABTCFString = (): Promise<string | null> => {
  return new Promise((resolve) => {
    if (typeof window.__tcfapi !== 'function') {
      console.warn('TCF API not available');
      resolve(null);
      return;
    }

    window.__tcfapi('getTCData', 2, (tcData, success) => {
      if (success && tcData?.tcString) {
        resolve(tcData.tcString);
      } else {
        console.warn('Failed to get TC string');
        resolve(null);
      }
    });
  });
};


/**
 * Appends the IAB TCF String to the stream URL
 * @param {string} url The original stream URL
 * @returns {Promise<string>} The modified stream URL with the IAB TCF String
 */
export const appendTCFToStreamUrl = async (url: string): Promise<string> => {
  const tcfString = await getIABTCFString();
  console.log("<<<<BANNER LISTENER>>>>> appendTCFToStreamUrl tcfString = " + tcfString);
  if (!tcfString) {
    return url;
  }

  // Add the TCF string as userConsentV2 parameter
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}aw_0_req.userConsentV2=${tcfString}`;
};



const initAdwizz = () => {
  /* @ts-expect-error */
  if (window.adswizzSDK) {
    /* @ts-expect-error */
    if (window.adswizzSDK) {
      /* @ts-expect-error */
      window.adswizzSDK.init({
        listenerConsent: false,
        contentPlayer: document.getElementById(config.contentElementId),
        playerId: "atunwa_web",
        companionBanner: {
          container: document.getElementById(config.companionElementId),
          size: [300, 250],
          baseURL: "https://atunwa.deliveryengine.adswizz.com/www/delivery/afr.php",
          zoneId: "2459",
          fallbackZoneId: "2461",
          alwaysDisplayAds: true,
          extraExposureTime: 5000,
          outOfContextListener : adsWizzCompanionOutOfContextFunction,
          willDisplayListener : adsWizzCompanionWillDisplayFunction,
          willDisplayFallbackListener : adsWizzCompanionWillDisplayFallbackFunction
        },
      });
    }
  }
};

export default initAdwizz;
